import React, { useEffect } from 'react';

const ChatWidget = () => {
  useEffect(() => {
    // Initialize Chatbase
    if (!window.chatbase || window.chatbase("getState") !== "initialized") {
      window.chatbase = (...args) => {
        if (!window.chatbase.q) {
          window.chatbase.q = [];
        }
        window.chatbase.q.push(args);
      };

      window.chatbase = new Proxy(window.chatbase, {
        get(target, prop) {
          if (prop === "q") {
            return target.q;
          }
          return (...args) => target(prop, ...args);
        },
      });

      // Load Chatbase script
      const script = document.createElement("script");
      script.src = "https://www.chatbase.co/embed.min.js";
      script.id = "nRUEORnYdmkOLGtHHLTWZ";
      script.domain = "www.chatbase.co";
      document.body.appendChild(script);
    }
  }, []);

  return null; // This component doesn't render anything visible
};

export default ChatWidget;
